"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IpfsService = void 0;

var utils_1 = require("../utils");

var IPFS = require("ipfs");

var IpfsService;

(function (IpfsService) {
  var _this = this;

  IpfsService.AddToIPFS = function (file, secretKey) {
    return __awaiter(_this, void 0, void 0, function () {
      var stringToUse, node, _a, id, agentVersion, protocolVersion, _b, _c, cid, e_1_1;

      var e_1, _d;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            stringToUse = file;

            if (secretKey) {
              stringToUse = utils_1.Utils.encryptSecret(file, secretKey);
            }

            return [4
            /*yield*/
            , IPFS.create({
              repo: String(Math.random() + Date.now())
            })];

          case 1:
            node = _e.sent();
            console.log("IPFS node is ready");
            return [4
            /*yield*/
            , node.id()];

          case 2:
            _a = _e.sent(), id = _a.id, agentVersion = _a.agentVersion, protocolVersion = _a.protocolVersion;
            console.log(id, agentVersion, protocolVersion);
            _e.label = 3;

          case 3:
            _e.trys.push([3, 8, 9, 14]);

            _b = __asyncValues(node.add(stringToUse));
            _e.label = 4;

          case 4:
            return [4
            /*yield*/
            , _b.next()];

          case 5:
            if (!(_c = _e.sent(), !_c.done)) return [3
            /*break*/
            , 7];
            cid = _c.value.cid;
            return [2
            /*return*/
            , {
              ipfsHash: cid.toString(),
              data: stringToUse
            }];

          case 6:
            return [3
            /*break*/
            , 4];

          case 7:
            return [3
            /*break*/
            , 14];

          case 8:
            e_1_1 = _e.sent();
            e_1 = {
              error: e_1_1
            };
            return [3
            /*break*/
            , 14];

          case 9:
            _e.trys.push([9,, 12, 13]);

            if (!(_c && !_c.done && (_d = _b.return))) return [3
            /*break*/
            , 11];
            return [4
            /*yield*/
            , _d.call(_b)];

          case 10:
            _e.sent();

            _e.label = 11;

          case 11:
            return [3
            /*break*/
            , 13];

          case 12:
            if (e_1) throw e_1.error;
            return [7
            /*endfinally*/
            ];

          case 13:
            return [7
            /*endfinally*/
            ];

          case 14:
            throw new Error("Failed to add data to IPFS");
        }
      });
    });
  };
})(IpfsService = exports.IpfsService || (exports.IpfsService = {}));